import React from 'react';

const TestComponent: React.FC = () => {
  console.log('TestComponent rendering...');

  return (
    <div className="min-h-screen bg-frost-white flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-title font-bold text-deep-navy mb-4">Test Component</h1>
        <p className="text-xl text-brand-blue">This is a test component</p>
        <p className="text-gray-600 mt-2">If you can see this, the component is rendering correctly</p>

        <div className="mt-8 space-y-4">
          <div className="bg-white rounded-2xl p-6 border border-ice-teal-light shadow-sm">
            <h3 className="text-lg font-title font-bold text-deep-navy mb-2">Test Card</h3>
            <p className="text-gray-500">This card should be visible with proper styling</p>
          </div>

          <div className="bg-red-50 border border-red-200 text-brand-red rounded-xl p-4">
            <p>Error notification style</p>
          </div>

          <div className="bg-ice-teal/20 border border-ice-teal text-brand-blue rounded-xl p-4">
            <p>Success notification style</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestComponent;
